import styled from 'styled-components';
import { light_theme_off_white } from '../../../constants/constants';
import {t} from 'i18next';
import { Container } from 'react-bootstrap';
const FooterContainer = styled.div`
    background-color: #EFEFEF;
    // display: flex;
    // flex-direction: row;
    // justify-content: space-between;
    padding: 14px 0;
    font-family: 'Roboto', sans-serif;
    font-weight: 400;
    font-size: 17px;
    margin-top: 2rem;
    @media (max-width: 500px) {
        font-size: 13px;
    }
`
export default function Footer() {
    return (
    <FooterContainer>
        <Container fluid className='d-flex justify-content-between'>
        <div>{t('general.footer.label.copyRight')}</div>

        <div>{t('general.footer.label.version')}</div>
        </Container>
    </FooterContainer>);
}